import React, { useEffect, useState } from 'react';
import { statusClass, formatMana, totalPrizePool, compareTournaments } from './format.js';

export default function LandingPage({ onOpen, onCreate }) {
  const [tournaments, setTournaments] = useState(null);
  const [loadError, setLoadError] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeFilter, setActiveFilter] = useState('All');

  useEffect(() => {
    fetch('/api/tournaments')
      .then(r => {
        if (!r.ok) throw new Error('Failed to load tournaments');
        return r.json();
      })
      .then(setTournaments)
      .catch(() => {
        setTournaments([]);
        setLoadError(true);
      });
  }, []);

  const filters = ['All', 'Active', 'Coming Up', 'Finished'];

  const filteredTournaments = (tournaments || [])
    .filter(t => {
      const q = searchTerm.trim().toLowerCase();
      const matchesSearch =
        !q ||
        t.name.toLowerCase().includes(q) ||
        (t.description || '').toLowerCase().includes(q) ||
        (t.tags || []).some(tag => tag.toLowerCase().includes(q));
      const matchesFilter = activeFilter === 'All' || t.status === activeFilter;
      return matchesSearch && matchesFilter;
    })
    .sort(compareTournaments);

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Tournaments</h1>
        <p className="page-subtitle">Compete in prediction tournaments and win prizes</p>
      </div>

      <div className="top-nav">
        {filters.map(filter => (
          <button
            key={filter}
            className={`nav-pill ${activeFilter === filter ? 'active' : ''}`}
            onClick={() => setActiveFilter(filter)}
          >
            {filter}
          </button>
        ))}
      </div>

      <div className="search-container">
        <input
          type="text"
          placeholder="Search tournaments..."
          className="search-bar"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="list-toolbar">
        <div className="list-count">
          {filteredTournaments.length} tournament{filteredTournaments.length !== 1 ? 's' : ''}
        </div>
        <button className="btn btn-primary" onClick={onCreate}>
          Create Tournament
        </button>
      </div>

      {tournaments === null ? (
        <div className="loading">Loading tournaments...</div>
      ) : filteredTournaments.length === 0 ? (
        <div className="card">
          <div className="center-message">
            {loadError
              ? 'Could not load tournaments. Try refreshing the page.'
              : searchTerm || activeFilter !== 'All'
                ? 'No tournaments match your criteria'
                : 'No tournaments yet — be the first to create one!'}
          </div>
        </div>
      ) : (
        <table className="tournaments-table">
          <thead>
            <tr>
              <th>Tournament</th>
              <th className="col-prizes">Prizes</th>
              <th className="col-status">Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredTournaments.map(t => {
              const pool = totalPrizePool(t.prizes);
              return (
                <tr key={t.id} onClick={() => onOpen(t.id)}>
                  <td>
                    <div className="row-title">{t.name}</div>
                    {t.description && (
                      <div className="row-description">
                        {t.description.length > 120 ? t.description.substring(0, 120) + '…' : t.description}
                      </div>
                    )}
                    {t.tags && t.tags.length > 0 && (
                      <div className="tags-list row-tags">
                        {t.tags.map(tag => (
                          <span key={tag} className="tag-chip">{tag}</span>
                        ))}
                      </div>
                    )}
                  </td>
                  <td className="col-prizes">
                    {pool > 0 ? <span className="prize-pool">{formatMana(pool)}</span> : <span className="muted">—</span>}
                  </td>
                  <td className="col-status">
                    <span className={`status-pill ${statusClass(t.status)}`}>{t.status}</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}
